import { signup } from './types';

const marketplaceReducerObject = {
  [signup.request]: (state) =>
    state
      .setIn(['signup', 'error'], false)
      .setIn(['signup', 'loading'], true)
      .setIn(['signup', 'success'], false)
      .setIn(['data'], null),
  [signup.success]: (state, action) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['signup', 'loading'], false)
        .setIn(['signup', 'error'], false)
        .setIn(['signup', 'success'], true)
        .setIn(['data'], action.response),
    ),
  [signup.failure]: (state, action) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['signup', 'loading'], false)
        .setIn(['signup', 'error'], action.error)
        .setIn(['signup', 'success'], false),
    ),
};

export default marketplaceReducerObject;
